import { getHeaders } from "#src/api/utils";

export const APIUpdateWFSAccess = async (wfsAccessData) => {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);

    const { type, entity_id, username, password } = wfsAccessData;

    if (!type || !entity_id || !username || !password) {
        throw new Error('Invalid data');
    }

    const requestOptions = {
        method: 'PUT',
        headers: headers,
        redirect: 'follow',
        body: JSON.stringify({
            type: type,
            entity_id: entity_id,
            username: username,
            password: password,
        }),
    };

    try {
        const apiUrl =
            process.env.REACT_APP_MODE === 'PROD'
            ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
            : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/wfs/1.0`, requestOptions);
        const responseObject = await response.json();
        const updatedWFSAccess = responseObject.data;

        if (updatedWFSAccess) {
            return updatedWFSAccess;
        }
        else {
            return null;
        }
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export const APICreateWFSAccess = async (wfsAccessData) => {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);
    const { type, entity_id, username, password } = wfsAccessData;
    if (!type || !entity_id || !username || !password) {
        throw new Error('Invalid data');
    }
    const requestOptions = {
        method: 'POST',
        headers: headers,
        redirect: 'follow',
        body: JSON.stringify({
            type: type,
            entity_id: entity_id,
            username: username,
            password: password,
        }),
    };
    try {
        const apiUrl =
            process.env.REACT_APP_MODE === 'PROD'
            ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
            : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/wfs/1.0`, requestOptions);
        const responseObject = await response.json();
        const createdWFSAccess = responseObject.data;

        if (createdWFSAccess) {
            return createdWFSAccess;
        } else {
            return null;
        }
    }
    catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export const APIGetWFSAccess = async (type, entity_id) => {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);
    
    if (!type || !entity_id) {
        throw new Error('Invalid data');
    }
    const requestOptions = {
        method: 'GET',
        headers: headers,
        redirect: 'follow',
    };
    try {
        const apiUrl =
            process.env.REACT_APP_MODE === 'PROD'
            ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
            : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/wfs/1.0?type=${type}&entity_id=${entity_id}`, requestOptions);
        const responseObject = await response.json();
        const wfsAccess = responseObject.data;

        console.log(wfsAccess);

        if (wfsAccess) {
            return wfsAccess;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}

export const APIDeleteWFSAccess = async (id) => {
    const headers = getHeaders(process.env.REACT_APP_API_INTERNAL_TOKEN);
    if (!id) {
        throw new Error('Invalid data');
    }
    const requestOptions = {
        method: 'DELETE',
        headers: headers,
        redirect: 'follow',
    };
    try {
        const apiUrl =
            process.env.REACT_APP_MODE === 'PROD'
            ? process.env.REACT_APP_API_INTERNAL_PRODUCTION
            : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
        const response = await fetch(`${apiUrl}/wfs/1.0/remove/${id}`, requestOptions);
        const responseObject = await response.json();
        const deletedWFSAccess = responseObject.data;

        if (deletedWFSAccess) {
            return deletedWFSAccess;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
}
